// extracted by mini-css-extract-plugin
export var background = "_ax-6";
export var containerMedium = "_ax-0";
export var containerMicro = "_ax-2";
export var containerSmall = "_ax-1";
export var dropdown = "_ax-5";
export var dropdownLabel = "_ax-a";
export var enter = "_ax-7";
export var exitActive = "_ax-8";
export var label = "_ax-3";
export var option = "_ax-9";
export var select = "_ax-4";